// Google's token model uses the signed-in browser account; access tokens stay in memory for this import only.
const SCOPE = 'https://www.googleapis.com/auth/drive.readonly';
interface TokenResponse { access_token?: string; scope?: string; error?: string }
export interface GoogleTokenClient { requestAccessToken(options?: { prompt?: string }): void }
interface GoogleOAuth {
  initTokenClient(options: { client_id: string; scope: string; include_granted_scopes: boolean; callback: (response: TokenResponse) => void; error_callback: (error: { type: string }) => void }): GoogleTokenClient;
  hasGrantedAllScopes(response: TokenResponse, ...scopes: string[]): boolean;
}
declare global { interface Window { google?: { accounts?: { oauth2?: GoogleOAuth } } } }

let loading: Promise<void> | undefined;
async function loadGoogle(): Promise<void> {
  if (window.google?.accounts?.oauth2) return;
  if (!loading) loading = new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');
    const fail = (): void => { clearTimeout(timer); script.remove(); reject(new Error('Google 로그인 모듈을 불러오지 못했습니다. 네트워크 또는 브라우저 차단 설정을 확인해 주세요.')); };
    const timer = setTimeout(fail, 15_000);
    script.src = 'https://accounts.google.com/gsi/client'; script.async = true;
    script.onload = () => { clearTimeout(timer); if (window.google?.accounts?.oauth2) resolve(); else fail(); };
    script.onerror = fail; document.head.append(script);
  }).catch(error => { loading = undefined; throw error; });
  return loading;
}

export async function googleTokenClient(clientId: string, success: (token: string) => void, failure: (message: string) => void): Promise<GoogleTokenClient> {
  await loadGoogle();
  const oauth = window.google!.accounts!.oauth2!;
  return oauth.initTokenClient({ client_id: clientId, scope: SCOPE, include_granted_scopes: false,
    callback: response => {
      if (response.error || !response.access_token || !oauth.hasGrantedAllScopes(response, SCOPE)) { failure('Google Drive 읽기 권한 승인이 필요합니다. Google 계정을 다시 연결해 주세요.'); return; }
      success(response.access_token);
    },
    error_callback: error => failure(error.type === 'popup_failed_to_open' ? 'Google 로그인 팝업이 차단되었습니다. 팝업을 허용한 뒤 다시 연결해 주세요.' : 'Google 계정 연결을 완료하지 못했습니다. 다시 연결해 주세요.'),
  });
}
